export default "__VITE_ASSET__CYZPjkSz__"